import React from 'react';
import dynamic from 'next/dynamic';
import { DynamicFormFieldType } from '../enum';

const HeadingField = dynamic(() => import('./HeadingField'), {
    ssr: false
});
const TextField = dynamic(() => import('./TextField'), {
    ssr: false
});
const ParagraphField = dynamic(() => import('./ParagraphField'), {
    ssr: false
});
const ButtonField = dynamic(() => import('./ButtonField'), {
    ssr: false
});
const NumberField = dynamic(() => import('./NumberField'), {
    ssr: false
});
const TextAreaField = dynamic(() => import('./TextAreaField'), {
    ssr: false
});
const RadioGroupField = dynamic(() => import('./RadioGroupField'), {
    ssr: false
});
const SelectField = dynamic(() => import('./SelectField'), {
    ssr: false
});
const CheckboxGroupField = dynamic(() => import('./CheckboxGroupField'), {
    ssr: false
});
const DateField = dynamic(() => import('./DateField'), {
    ssr: false
});

interface FormState {
    isSent: boolean;
    isProcessing: boolean;
}

interface FieldProps {
    config: DynamicFormFieldConfig;
    formState: FormState;
}

const Field = ({ config, formState }: FieldProps): JSX.Element => {
    switch (config.type) {
        case DynamicFormFieldType.Text:
            return <TextField config={config} />;
        case DynamicFormFieldType.Button:
            return <ButtonField config={config} formState={formState} />;
        case DynamicFormFieldType.TextArea:
            return <TextAreaField config={config} />;
        case DynamicFormFieldType.CheckBoxGroup:
            return <CheckboxGroupField config={config} />;
        case DynamicFormFieldType.Number:
            return <NumberField config={config} />;
        case DynamicFormFieldType.DatePicker:
            return <DateField config={config} />;
        case DynamicFormFieldType.RadioGroup:
            return <RadioGroupField config={config} />;
        case DynamicFormFieldType.Select:
            return <SelectField config={config} />;
        case DynamicFormFieldType.Paragraph:
            return <ParagraphField config={config} />;
        case DynamicFormFieldType.Header:
            return <HeadingField config={config} />;
    }
};

export default Field;
